/**
 * @title zoom-viewer.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the zoom viewer component of quickview display.
 * @dependency 
 */
define([], function() {
  var ModalZoomViewer = {

    initialized: false,

    getViewerSize: function() {
      let width = $(window).width();
      let height = $(window).height();
      if (width > 1000 && height > 870) return zoomViewer.xl;
      if (width > 764 && height > 729) return zoomViewer.lg;
      if (width > 750 && height > 600) return zoomViewer.md;
      return zoomViewer.xs;
    },
    
    /**
     * Invoked on event trigger 'richmedia.state.loaded'
     */
    richMediaLoaded: function() {
      console.log("PDP Image Modal: Enter richMediaLoaded");

      ModalZoomViewer.init();
      ModalZoomViewer.setupViewer();
      //ModalZoomViewer.setupSwatches();
      ModalZoomViewer.constants.$viewerDiv.css('visibility', 'visible');
      ModalZoomViewer.constants.$viewerDiv.find('#imageHolder').focus();
      
      if (ModalZoomViewer.hasVideoContent()) {
        ModalZoomViewer.loadVideoData();
      }

      ModalZoomViewer.showHideControls();

      ModalZoomViewer.setUpADA();
      console.log("PDP Image Modal: Exit richMediaLoaded");
    },

    hasVideoContent: function() {
      let $externalVideo = ModalZoomViewer.constants.$theViews.find('img[id*=External]');
      let videoContent = false;
      if ($externalVideo.length > 0) {
        videoContent = true;
      }

      console.log("PDP Image Modal: Has video content = " + videoContent);
      return videoContent;
    },
    
    richMediaSwatchChange: function() {
      if (ModalZoomViewer.constants.$theViews.hasClass('slick-initialized')) {
        ModalZoomViewer.destroyThumbnailCarousel();
        ModalZoomViewer.makeViewerResponsive();
        ModalZoomViewer.setupThumbnailCarousel();
      }
    },
    
    /**
     * Invoked on event trigger 'richmedia.view.changed'
     */
    richMediaViewChange: function() {
      ModalZoomViewer.destroyThumbnailCarousel();
      ModalZoomViewer.makeViewerResponsive();
      ModalZoomViewer.setupThumbnailCarousel();

      ModalZoomViewer.showHideControls();
      ModalZoomViewer.setUpADA();

      let $selected = $('#modalViews .RICHFXColorChangeViewSelected');
      let selectedIndex = $('#modalThumbnails').find('img').index($selected) + 1;

      $selected.focus();
      var currentImageIndex = $selected.closest('a').index();
      setTimeout(function(){
          ModalZoomViewer.setupADAValuesForHeroImage(currentImageIndex);
      }, 500);
    },

    init: function() {
        console.log('PDP Image Modal: Calling ModalZoomViewer.init...');   
        ModalZoomViewer.constants = {
          $viewerDiv: $('#modalModalZoomViewer'),
          $viewerLib: $('#productImageLibrary'),
          $viewerImg: $('#modalImage'),
          $thumbnails: $('#modalThumbnails'),
          $theViews: $('#modalViews'),
          $initialImage: $('#initialProductImage'),
          $prevArrow: $('#viewsPrevArrow'),
          $nextArrow: $('#viewsNextArrow'),
          totalSlidesCount: $('#modalViews').find('a').length,
          viewerSize: ModalZoomViewer.getViewerSize()+'Multi'
      };
        let $selected = $('#modalViews .RICHFXColorChangeViewSelected');
        let selectedIndex = $('#modalThumbnails').find('img').index($selected) + 1;
 
        ModalZoomViewer.bindNextArrowEvent();
        ModalZoomViewer.bindPrevArrowEvent();

        //next four lines makes panning utility working for Firefox
        if (!COSTCO.util.isIE11OrOlder()) {
            $('.modal-zoom-pan').removeClass('hidden-until-focus');
            $('.modal-zoom-pan').addClass('hidden-until-focus');
        }

        var currentImageIndex = $selected.closest('a').index();
        setTimeout(function(){
            ModalZoomViewer.setupADAValuesForHeroImage(currentImageIndex);
            ModalZoomViewer.trapFocusInsideModal();
            ModalZoomViewer.bindZoomAndPanEvents();
        }, 200);
        ModalZoomViewer.loaded();
     },

     setupADAValuesForHeroImage: function(imageIndex) {
	   if (imageIndex == 0) {
		 imageIndex = 1;
	   } else {
		 if (!ModalZoomViewer.hasVideoContent()) {
		   imageIndex = imageIndex + 1;
	     }
	   }
	   $('div[id ^="RICHFXViewerContainer___richfx_id_"][tabindex=0]').find('img').removeAttr("aria-label");
	   $('div[id ^="RICHFXViewerContainer___richfx_id_"][tabindex=0]').find('img').removeAttr("title");
	   // want to change alt attribute only on modal instance of hero image
	   $('img[id ^="RICHFXViewerContainer___richfx_id_"][id $="_initialImage"]:not([id ^="RICHFXViewerContainer___richfx_id_0"]').find('img').attr("alt", "");
	   $('img[id ^="RICHFXViewerContainer___richfx_id_"][id $="_initialImage"]:not([id ^="RICHFXViewerContainer___richfx_id_0"]').attr("alt", messages.PDETAIL_VIEW_LARGER_IMAGE + " " + imageIndex);
     },
     
     
     /**  
      * Gets the position index of the selected slide element, starts from 0
      */
     getCurrentSlideIndex: function() {
      let slideIndex = 0;
      let $selected = $('#modalViews .RICHFXColorChangeViewSelected');
      if ($selected.length > 0) {
        slideIndex = $selected.closest('a').index();
      }
     
      console.log('PDP Image Modal: Real current slide index = ' + slideIndex);
      return slideIndex;
     },

     /**
      * Gets current slide number for display purposes, starts from 1
      */
     getCurrentSlideNumber: function() {
      let slideNumber = ModalZoomViewer.getCurrentSlideIndex() + 1;
      console.log('PDP Image Modal: Current slide display number = ' + slideNumber);
      return slideNumber;
     },
     
     /**
      * Executes when click on arrow for the next slide
      */
     bindNextArrowEvent: function() {
      $('#viewsNextArrow').on('click', function(){
         
        let slides = ModalZoomViewer.constants.totalSlidesCount;
        let currentSlideIndex  = ModalZoomViewer.getCurrentSlideIndex();
        if (currentSlideIndex < (slides - 1)) {
          let nextSlideIndex= currentSlideIndex + 1;
          let nextSlide = $('#modalViews').find('a')[nextSlideIndex];
          console.log('PDP Image Modal: Display next slide = ' + nextSlideIndex);
             
          $(nextSlide).find('img').click();
          $('.selectedSlide').first().focus();
        }
       });
     },
     
     /**
      * Executes when click on arrow for the previous slide
      */
     bindPrevArrowEvent: function() {
      $('#viewsPrevArrow').on('click', function() {
        let currentSlideIndex  = ModalZoomViewer.getCurrentSlideIndex();
        if (currentSlideIndex > 0) {
          let prevSlideIndex = currentSlideIndex - 1;
          let prevSlide = $('#modalViews').find('a')[prevSlideIndex];
          console.log('PDP Image Modal: Display previous slide = ' + prevSlideIndex);
             
          $(prevSlide).find('img').click();
          $('.selectedSlide').first().focus();
        }   
       });
     },
     
     bindZoomAndPanEvents: function() {
    	 $('#zoomAndPanImage_arrow_up').on('click', function(event) {
     		console.log("PDP Image Modal: Pan arrow UP ");
               RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panup');
     	 });
  
     	 $('#zoomAndPanImage_arrow_right').on('click', function(event) {
     		console.log("PDP Image Modal: Pan arrow RIGHT ");
               RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panright');
     	 });       	 
     	 
     	 $('#zoomAndPanImage_arrow_down').on('click', function(event) {
     		console.log("PDP Image Modal: Pan arrow DOWN ");
               RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.pandown');
     	 }); 
     	 
     	 $('#zoomAndPanImage_arrow_left').on('click', function(event) {
     		console.log("PDP Image Modal: Pan arrow LEFT ");
               RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panleft');
     	 }); 
     	 
     	 $('#zoomAndPanImage_magnifier_in').on('click', function(event) {
     		console.log("PDP Image Modal: Zoom Magnifier ");
               RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('clicked.zoombehavior');
     	 });     	 
     },
        
    //adjusts thumbnail width and position of video overlay images
    adjustThumbnails: function() {
      var viewerSize = ModalZoomViewer.getViewerSize();    
      let thumbWidth = viewerSize === zoomViewer.xl ? 90 : viewerSize ===  zoomViewer.lg ? 60 : 45; 
      ModalZoomViewer.constants.$theViews.find('img').css('width', thumbWidth);
      
      let $vidOverlay = $('img[id*=videoOverlay]');
      $vidOverlay.each(function() {
        $(this).parent().css('width', '');
        $(this).parent().css('height', '');
        $(this).css('left', $(this).siblings().position().left);
      });
    },
    
    //adds responsive properties to the zoom viewer
    makeViewerResponsive: function() {
      let $container = $('.RICHFXViewerContainer');
      $container.css('width', '');
      $container.css('height', '');
      $container.css('cursor', 'url(../../CostcoGLOBALSAS/images/product-zoom.cur),auto');
      $('#modalModalZoomViewer').find('img').addClass('img-responsive');
    },
    setUpADA: function(){
      //This id is changing need to find another selector for the main image
    $("#imageHolder").find("[id$='_initialImage']")
    .attr('tabindex','0')
    $('#modalViews').find('a').each(function(index) {
      $(this).find('span').attr('aria-hidden','true');
      $(this).attr('tabindex','-1')
      .find('img')
      .attr('tabindex','0')
      .attr('aria-label',messages.PREVIEW + ' ' + (++index));
      $(this).find('img')
      .attr('aria-hidden','false');
      $(this).attr('aria-hidden','false');
    });
    $('#viewsPrevArrow').attr('aria-disabled','false');
    $("#viewsNextArrow").on('focus click', function() {
    	$('#viewsNextArrow').attr('aria-disabled', 'false');
    });
    $('#imageHolder').find('img').removeAttr('tabindex');
    $('#imageHolder').children('div').attr('tabindex','0');
    ModalZoomViewer.setupTabindexForVideoThumbnail();
    },
    
    //creates thumbnail carousel
    setupThumbnailCarousel: function() {      
      let responsiveBreakpoints = [];
      
      let slickSettings = {
        arrows: true,
        slidesToShow: 3,
        dots: true,
        infinite: false,
        slidesToScroll: 4,
        autoplay: false,
        draggable: ModalZoomViewer.draggableThumbnails(),
        accessibility: true,
        variableWidth: true,
        prevArrow: $('#viewsPrevArrow'),
        nextArrow: $('#viewsNextArrow')
      }
      //Show dots on mobile
      if(ModalZoomViewer.getViewerSize() === zoomViewer.xs){
        slickSettings.arrows = false;
      }
      
      COSTCO.util.carousel(ModalZoomViewer.constants.$theViews, slickSettings);
      ModalZoomViewer.constants.$theViews.find('a').on('keyup', function(e) {
        //If user use keyboard enter key to select image simulate the click
        if (e.which == 13) {
          $(this).find('img').click();
        }
      });

      ModalZoomViewer.adjustThumbnails();
      ModalZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
      ModalZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
    },
    
    draggableThumbnails: function() {
    	if ($(window).width() < 1025) return true;
    	return false;
    },
    
    //destroys thumbnail carousel
    destroyThumbnailCarousel: function() {
      ModalZoomViewer.constants.$theViews.slick('destroy');
      ModalZoomViewer.constants.$theViews.find('a[tabindex]').remove();
      ModalZoomViewer.constants.$prevArrow.css('visibility', 'hidden');
      ModalZoomViewer.constants.$nextArrow.css('visibility', 'hidden');
    },
    
    //uses liveclicker's scripts to setup videos
    loadVideoData: function() {
      COSTCO.Global.logger('External Video Detected. Loading Brandfolder videos.');
      $('div#openModal').find('div#modalContainer').prepend($('#videoViewer-popup'));
    },
    
    hideZoomInstruction: function() {
      $('#zoomInstruction').addClass('hidden-preserve-height');
      $('#imageHolder').hide();
      $('#videoViewer-popup').show();
      ModalZoomViewer.showHideControls();
    },

    showZoomInstruction: function() {
      $('#zoomInstruction').removeClass('hidden-preserve-height');
      $('#videoViewer-popup').hide();
      $('#imageHolder').show();
    },
    
    //selects the first available swatch color from our side so
    //that the customer will not see a color that's unavailable.
    selectInitialSwatch: function() {
      let swatch;
      try {
      swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
        //trigger a select of the first swatch color from the color select dropdown
        COSTCO.CMath.triggerSwatchDropDownSelection(swatch);
      } catch(err) {
        console.error(err);
      }
      $('#theSwatches').find('img[alt="'+swatch+'"]').first().click();
    },
    
    //out of stock items do not reflect properly in the swatch tiles from rich media
    //so we have to sync their tiles with our product options.
    syncSwatchTiles: function(swatchMode) {
      var colorsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
      if($(option).attr("disabled") != "disabled"){
          return $(option).data('swatch').trim().toLowerCase(); 
        }
    });
    var colorsOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
      if($(option).attr("disabled") == "disabled"){
          return $(option).data('swatch').trim().toLowerCase(); 
        }
    });
    var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
      if($(option).text().includes(messages.BACKORDER_TEXT)) {
        var sliceStr = ' - '+ messages.BACKORDER_TEXT;
        return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
      } else if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
        var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
        return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
      } else if($(option).text().includes(' -')) {
        return $(option).text().slice(0, $(option).text().indexOf(' -'))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
      } else {
        return $(option).text() + " -"+$(option).data('swatch').trim().toLowerCase()+"-";
      }  
    });
      
      $('img', '#theSwatches').each(function() {
        var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
        if (itemDescriptionArray.length == 2) {
          var color = itemDescriptionArray[1].toLowerCase();
          var colorNameTitle = $.map(colorsNames, function (value){
        if(value.includes(' -'+color)){
          return value.slice(0, value.indexOf(' -'+color+'-')); 
        }
          });
          if (colorsInStock.indexOf(color) < 0 && colorsOutStock.indexOf(color) < 0) {
      $(this).parent().remove();
          } else if(colorsInStock.indexOf(color) < 0 ) {
      $(this).parent().addClass('disabledSwatch');
      if(color == 'white'){
        $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
      }else {
        $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
      }
      $(this).parent().get(0).setAttribute("tabindex", "-1");
      $(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" data-toggle="popover" data-html="true" data-content="'+colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
      $(this).parent().prepend('<span class="offscreen">' +colorNameTitle + ' '+ messages.OUT_OF_STOCK_TOOLTIP +'</span>');
          }else {
      $(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
      
      $(this).parent().get(0).setAttribute("data-content", colorNameTitle);
      $(this).parent().get(0).setAttribute("data-placement", "bottom");
      $(this).parent().get(0).setAttribute("data-trigger", "focus hover");
      $(this).parent().get(0).setAttribute("data-toggle", "popover");
      $(this).parent().get(0).setAttribute("data-html", "true");
      $(this).parent().get(0).classList.add("swatch-help");
      $(this).parent().get(0).setAttribute("onkeydown", "COSTCO.CMath.runRMAActiveColor(event, '" + color + "')");
          }
        }
      });
      
      var sortedSwatches = $('#theSwatches').children().sort(function(a,b){
        return a.getAttribute('data-sort') - b.getAttribute('data-sort');
      });
      
      $('#theSwatches').empty();
      $('#theSwatches').append(sortedSwatches);
      if (swatchMode == 2) {
        $('#theSwatches').removeClass('hide');
      }
    },
    
    //sets up swatches based on swatchMode
    //swatchMode = 1 is the regular dropdown
    //swatchMode = 2 is RichFx's swatch color tiles and we hide our dropdown
    setupSwatches: function() {
      let swatchMode = $('.swatchDropdown').data('swatch-mode');
      
      if (swatchMode == 1 || swatchMode == 2) {
        ModalZoomViewer.syncSwatchTiles(swatchMode);
        ModalZoomViewer.selectInitialSwatch();
        
        //fallback to our select if RichFx's swatch tiles didn't load
        if (swatchMode == 2 && $('#theSwatches').children().length == 0) {
          $('.swatchDropdown').removeClass('hide');
        }
        COSTCO.util.swatch_accesible_popover('.swatch-help');
      } else {
      $('#product-body-item-number').removeClass('hide');
      $('#product-body-model-number').removeClass('hide');
      }
    },
    
    //setus up the viewer to have responsive properties and
    //shows thumbnails if they are available
    setupViewer: function() {
      ModalZoomViewer.makeViewerResponsive();
      if (ModalZoomViewer.constants.totalSlidesCount > 0) {
        ModalZoomViewer.constants.$thumbnails.show();
        ModalZoomViewer.setupThumbnailCarousel();
      }
    },
    
    /**
     * This event-bound function "locks" window position, since the external Liveclicker library has several
     * window.scrollTo() executions that cause the background to scroll down after each click on a video.
     */ 
    lockWindowScrolling: function(event) {
      if (typeof event.data.position != 'undefined') {
        $(window).scrollTop(event.data.position);
      }
    },
    /**
     * Liveclicker library may break, leaving the thumbnails un-reloaded.
     * Until this is fixed on the Liveclicker side, use this error event listener function.
     */ 
    reloadThumbnailsOnScriptError: function(event) {
      if (event.originalEvent.message == 'Script error.') {
        try {
          console.error('A script error occurred. Reloading thumbnails.');
          ModalZoomViewer.richMediaViewChange();
        } catch (err) {
          console.error('An error occurred while trying to reload thumbnails.');
        }
      }
    },
    /**
     * Shows modal previous item image arrow
     */
    showPreviousArrow: function() {
      ModalZoomViewer.constants.$prevArrow.removeClass('slick-disabled');
      $('#viewsPrevArrow').removeClass('hideViewsArrow');
      $('#viewsPrevArrow').css('display','');
      $('#viewsPrevArrow').attr('tabindex', '0');
    },
    /**
     * Hides modal previous item image arrow
     */
    hidePreviousArrow: function() {
      ModalZoomViewer.constants.$prevArrow.addClass('slick-disabled');
      $('#viewsPrevArrow').addClass('hideViewsArrow');
      $('#viewsPrevArrow').attr('tabindex', '-1');
    },
    /**
     * Shows modal next item image arrow
     */
    showNextArrow: function() {
      ModalZoomViewer.constants.$nextArrow.removeClass('slick-disabled');
      $('#viewsNextArrow').removeClass('hideViewsArrow');

      $('#viewsNextArrow').css('display','');
      $('#viewsNextArrow').attr('tabindex', '0');
    },
    /**
     * Hides modal next item image arrow
     */
    hideNextArrow: function() {
      ModalZoomViewer.constants.$nextArrow.addClass('slick-disabled');
      $('#viewsNextArrow').addClass('hideViewsArrow');
      $('#viewsNextArrow').attr('tabindex', '-1');
    },
    

    showHidePreviousArrow: function(cSlideIndex, slides) {
      console.log('PDP Image Modal: showHidePreviousArrow(' + cSlideIndex + ', ' + slides +')');

      if (slides == 0 || cSlideIndex == 0) {
        console.log('PDP Image Modal: Hide previous arrow');
        ModalZoomViewer.hidePreviousArrow();

      } else {
        console.log('PDP Image Modal: Show previous arrow');
        ModalZoomViewer.showPreviousArrow();
      }


    },

    showHideNextArrow: function(cSlideIndex, slides) {
      console.log('PDP Image Modal: showHideNextArrow(' + cSlideIndex + ', ' + slides +')');
      if (cSlideIndex < (slides - 1)) {
        console.log('PDP Image Modal: Show next arrow');
        ModalZoomViewer.showNextArrow();

      } else {
        console.log('PDP Image Modal: Hide next arrow');
        ModalZoomViewer.hideNextArrow();
      }
    },

    showHideClickHereToZoomOverlay: function(slides) {
      if (slides > 0) {
        let cSlideNumber =  ModalZoomViewer.getCurrentSlideNumber();
        $('#currentSlide').html(cSlideNumber +  messages.PDP_REDESIGN_V2_OF + slides);

      } else {
        $('#currentSlide').hide();
      }

    },

    showHideControls: function() {
      let slides = ModalZoomViewer.constants.totalSlidesCount;
      let cSlideIndex = ModalZoomViewer.getCurrentSlideIndex();
      ModalZoomViewer.showHidePreviousArrow(cSlideIndex, slides);
      ModalZoomViewer.showHideNextArrow(cSlideIndex, slides);
      ModalZoomViewer.showHideClickHereToZoomOverlay(slides);
    },
    
    setupTabindexForVideoThumbnail: function() {
	  var $vidOverlay = $('img[id*=videoOverlay]');
	  $vidOverlay.each(function() {
		$(this).attr('tabindex',-1);
	  });
	},
	/**
	 * Overrides trapFocusInside from utility modal function
	 * to get aria element as focusable element
	 */
	trapFocusInsideModal: function() {
		let modalBody = $(".modal-dialog").get(0);
        if (modalBody != undefined) {
            let focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
            let focusableVisible = ModalZoomViewer.returnAllFocusableVisibleElements(focusableElements);
            if (focusableVisible.length > 0) {
                let firstElement = focusableVisible[0];
                let lastElement = focusableVisible[focusableVisible.length - 1];
                COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
            }
        }
	},
    /**
     * Returns all elements including area element
     */
    returnAllFocusableVisibleElements: function(focusableElements){
        let visibleFocusable = [];

        function findVisibleElements(item, index) {
            $(item).unbind('keydown');
            //Does element or its parent has display none
            if(item.style.display !== "none" && item.offsetParent !== null) {
                if ($(item).is(':visible') || $(item).is('area')) {
                    visibleFocusable.push(item);
                }
            }
        }

        for (var i = 0; i < focusableElements.length; i++) {
            findVisibleElements(focusableElements[i]);
        }
        return visibleFocusable;
    },
    /**
     * Fires the ModalZoomViewerLoaded event.
     */
    loaded: function() {
      COSTCO.Global.notify('ModalZoomViewerLoaded');
    },

  }
  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.ModalZoomViewer = ModalZoomViewer;
  
  
  return ModalZoomViewer;
});




// WEBPACK FOOTER //
// ./js/product/modalZoom-viewer.js